import { render, staticRenderFns } from "./QuestionScoresSlide.vue?vue&type=template&id=17fabab3&scoped=true&"
import script from "./QuestionScoresSlide.vue?vue&type=script&lang=js&"
export * from "./QuestionScoresSlide.vue?vue&type=script&lang=js&"
import style0 from "./QuestionScoresSlide.vue?vue&type=style&index=0&id=17fabab3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fabab3",
  null
  
)

export default component.exports